"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _marqueePicture = _interopRequireDefault(require("../../page-header/marquees/common/marquee-picture"));
var _inlineVideo = _interopRequireDefault(require("../../elements/other/inline-video"));
var _boxModelSize = require("@site/pattern-library-utils/box-model-size");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function hasImageMedia(portrait, landscape, tablet) {
  return Boolean(portrait?.url || landscape?.url || tablet?.url);
}
function hasVideoMedia(videoProps) {
  const {
    introUrl,
    introUrlWebm,
    introUrlLaptop,
    introUrlLaptopWebm,
    videos
  } = videoProps || {};
  return Boolean(introUrl || introUrlWebm || introUrlLaptop || introUrlLaptopWebm || videos && /*#__PURE__*/_react.default.isValidElement(videos));
}

/**
 * MediaContent Component
 *
 * Handles rendering of images and videos for marquee components.
 * Supports both static images (portrait/landscape) and video content.
 *
 * @param {Object} props Component props
 * @param {Object} props.portrait Portrait image props
 * @param {Object} props.landscape Landscape image props
 * @param {Object} props.videoProps Video configuration props
 * @param {boolean} props.paused Whether video should be paused
 * @param {boolean} props.isActive Whether this content is currently active
 * @returns {React.ReactElement|null} MediaContent Component or null if no media
 */
function MediaContent({
  portrait,
  landscape,
  tablet,
  videoProps,
  paused,
  isActive
}) {
  const hasImage = hasImageMedia(portrait, landscape, tablet);
  const hasVideo = hasVideoMedia(videoProps);
  const videoKeyRef = (0, _react.useRef)(0);
  (0, _react.useEffect)(() => {
    if (isActive && hasVideo) {
      videoKeyRef.current += 1;
    }
  }, [isActive, hasVideo]);
  if (!hasImage && !hasVideo) return null;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasImage && /*#__PURE__*/_react.default.createElement(_marqueePicture.default, {
    portrait: portrait,
    landscape: landscape,
    tabletPortraitBackground: tablet,
    imgLoading: "eager"
  }), hasVideo && /*#__PURE__*/_react.default.createElement(_inlineVideo.default, (0, _extends2.default)({
    key: videoKeyRef.current
  }, videoProps, {
    paused: paused,
    loop: true,
    hidePlayButton: true,
    preload: "metadata"
  })));
}
MediaContent.propTypes = {
  portrait: _propTypes.default.shape(_boxModelSize.bynderImageProps),
  landscape: _propTypes.default.shape(_boxModelSize.bynderImageProps),
  tablet: _propTypes.default.shape(_boxModelSize.bynderImageProps),
  videoProps: _propTypes.default.shape({
    thumbnailDesktop: _propTypes.default.string,
    thumbnailMobile: _propTypes.default.string,
    introUrl: _propTypes.default.string,
    introUrlWebm: _propTypes.default.string,
    introUrlLaptop: _propTypes.default.string,
    introUrlLaptopWebm: _propTypes.default.string,
    videos: _propTypes.default.node,
    preload: _propTypes.default.string,
    hidePlayButton: _propTypes.default.bool
  }),
  paused: _propTypes.default.bool,
  isActive: _propTypes.default.bool
};
var _default = exports.default = MediaContent;